import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Directive({
  selector: '[throttleClick]',
  standalone: true,
})
export class ThrottleClickDirective {
  @Input() throttleTime = 1000;
  @Output() throttleClick = new EventEmitter();

  private clicks = new Subject();

  constructor() {
    this.clicks.pipe(
      throttleTime(this.throttleTime),
      takeUntilDestroyed()
    ).subscribe(e => this.throttleClick.emit(e));
  }


  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
